import { ACTIVE, INACTIVE } from 'AccountsApp/ts/constants/integrations.constants';
import { PershingIntegrationService } from 'IntegrationsApp/ts/services/pershing-integration-service';
import { PershingActivateModalComponent } from '../pershing-activate-modal/pershing-activate-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/pershing-integration-service";
import * as i2 from "Angular/features/directives/image/image.directive";
import * as i3 from "../integration-status-indicator/integration-status-indicator.component";
import * as i4 from "../pershing-activate-modal/pershing-activate-modal.component";
const _c0 = ["ycn-pershing-integration-list-item", ""];
export class PershingIntegrationListItemComponent {
    constructor(pershingIntegrationService) {
        this.pershingIntegrationService = pershingIntegrationService;
        this.status = '';
        this.errorMessage = '';
    }
    ngOnInit() {
        this.updateStatus();
    }
    updateStatus() {
        this.pershingIntegrationService.getPershingIntegrationStatus().subscribe({
            next: (data) => {
                this.status = data.isActive ? ACTIVE : INACTIVE;
            },
            error: () => { },
        });
    }
    cancelActivation() {
        this.status = INACTIVE;
    }
    activateToggle() {
        if (this.status === INACTIVE) {
            this.status = ACTIVE;
            this.pershingActivateModalComponent.openModal();
        }
    }
}
PershingIntegrationListItemComponent.ɵfac = function PershingIntegrationListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PershingIntegrationListItemComponent)(i0.ɵɵdirectiveInject(i1.PershingIntegrationService)); };
PershingIntegrationListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PershingIntegrationListItemComponent, selectors: [["tr", "ycn-pershing-integration-list-item", ""]], viewQuery: function PershingIntegrationListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PershingActivateModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pershingActivateModalComponent = _t.first);
    } }, inputs: { clientId: "clientId", authUrl: "authUrl", redirectUri: "redirectUri" }, standalone: false, attrs: _c0, decls: 14, vars: 4, consts: [[1, "table-logo"], ["ycnImage", "", 3, "imageSrc"], [1, "text-bold"], [3, "status"], [1, "text-right"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "disabled", "checked"], [1, "custom-control-indicator"], [3, "closeModalHandler"]], template: function PershingIntegrationListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "td")(1, "div", 0);
        i0.ɵɵelement(2, "img", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵtext(4, "Pershing");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "td");
        i0.ɵɵtext(6, "Portfolio Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "td");
        i0.ɵɵelement(8, "ycn-integration-status-indicator", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "td", 4)(10, "label", 5)(11, "input", 6);
        i0.ɵɵlistener("change", function PershingIntegrationListItemComponent_Template_input_change_11_listener() { return ctx.activateToggle(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "span", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "ycn-pershing-activate-modal", 8);
        i0.ɵɵlistener("closeModalHandler", function PershingIntegrationListItemComponent_Template_ycn_pershing_activate_modal_closeModalHandler_13_listener() { return ctx.cancelActivation(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("imageSrc", "integrations/images/pershing-logo.png");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("status", ctx.status);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.status === "active")("checked", ctx.status === "active");
    } }, dependencies: [i2.ImageDirective, i3.IntegrationStatusIndicatorComponent, i4.PershingActivateModalComponent], encapsulation: 2 });
